@for (accordion of accordions; track accordion.id; let index = $index) {
    <span [attr.data-menu-item-id]="accordion.id">
        @if (!accordion.isCollapsed && (accordion.grid | async); as gridModel) {
            <ms-grid
                [model]="gridModel"
                [iconTemplate]="header"
                [hideMarketSwitcher]="accordion.hideMarketSwitcher"
                (toggleAccordionClick)="toggleAccordion(accordion, $event)" />

            @if (isShowMoreEnabled && getEventsAvilable(accordion)) {
                <div id="{{ accordion.id + index }}" class="showmore toggle" (click)="onShowMoreClick(accordion, index)">
                    <span>{{ accordion.isShowMoreExpanded ? sitecore.globalMessages.ShowLess : sitecore.globalMessages.ShowMore }}</span>
                    <vn-icon class="show-more-icon" size="12" [name]="accordion.isShowMoreExpanded ? 'theme-up' : 'theme-down'" />
                </div>
            }

            @if (accordion.linkConfig && accordion.linkConfig.link && accordion.linkConfig.title) {
                <div class="grid grid-footer">
                    <ms-item
                        [count]="accordion.linkConfig.count"
                        [href]="accordion.linkConfig.link"
                        [tracking]="undefined"
                        (click)="linkClick(accordion)">
                        <span item-title [innerHtml]="accordion.linkConfig.title | msTrust: 'html'"></span>
                    </ms-item>
                </div>
            }
        } @else {
            <div class="grid grid-header grid-padding grid-border-bottom" (click)="onAccordionClick(accordion)">
                <div class="grid-title">
                    <ng-template *ngTemplateOutlet="header" />
                    <ng-template *ngTemplateOutlet="toggleTemplate" />
                </div>
            </div>
        }

        <ng-template #header>
            @if (accordion.display === displayType.Logo) {
                <ms-competition-logo
                    class="sport-icon"
                    [sportId]="accordion.sportId"
                    [leagueId]="accordion.itemId"
                    [fallbackIcon]="accordion.icon"
                    [isLogoOverrideEnabled]="true" />
            } @else {
                <vn-icon class="sport-icon" [name]="accordion?.icon ?? ''" [size]="isEpcotEnabled ? '24' : '16'" />
            }
            <span class="sport-name">{{ accordion.title }}</span>
        </ng-template>
        <ng-template #toggleTemplate>
            @if (accordion.isCollapsed) {
                <div class="toggle">
                    <vn-icon class="toggle-down-icon" name="theme-down" size="15" />
                </div>
            }
        </ng-template>
    </span>
}
